import { render, staticRenderFns } from "./ModalFuelTypeNew.vue?vue&type=template&id=6b715124&"
import script from "./ModalFuelTypeNew.vue?vue&type=script&lang=js&"
export * from "./ModalFuelTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports